import { apiSlice } from "../api/apiSlice";

export const quizApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({


        getAllQuizs: builder.query({
            query: () => ({
                url: "/quizzes",
                method: "GET",
            }),
        }),

        postQuiz: builder.mutation({
            query: (data) => ({
                url: "/quizzes",
                method: "POST",
                body: data,
            }),


            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;


                    if (result?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllQuizs", undefined,
                                (draft) => {
                                    draft.push({...arg,id:draft.length +1})

                                }
                            ))
                    }




                } catch (err) {
                    // do nothing
                }
            },

        }),

        getSQuiz: builder.query({
            query: (id) => ({
                url: `/quizzes/${id}`,
                method: "GET",
            }),
        }),
        getQuiz: builder.query({
            query: ({ videoId }) => ({
                url: `/quizzes?video_id=${videoId}`,
                method: "GET",
            }),
        }),


        updateQuiz: builder.mutation({
            query: ({ id, data }) => ({
                url: `/quizzes/${id}`,
                method: "PATCH",
                body: data,

            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

                  

                    if (result?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllQuizs", undefined,
                                (draft) => {
                                    const draftQuiz = draft.find(
                                        (c) => c.id == arg.id
                                    );
    
                              
                                    draftQuiz.options = arg.data.options;
                                    draftQuiz.question = arg.data.question;
                                    draftQuiz.video_title = arg.data.video_title;
                                    draftQuiz.video_id = arg.data.video_id;

                                }
                            ))
                    }




                } catch (err) {
                    // do nothing
                }
            },
        }),
        deleteQuiz: builder.mutation({
            query: (id) => ({
                url: `/quizzes/${id}`,
                method: "DELETE",


            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

              

                    if (result?.meta?.response?.status==200) {
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getAllQuizs", undefined,
                                (draft) => {
                                    draft.splice(draft.findIndex(q=>q.id ==arg.id),1)
    

                                }
                            ))
                    }




                } catch (err) {
                    // do nothing
                }
            },

            
        }),
    }),
});

export const { useGetQuizQuery, useGetAllQuizsQuery, useDeleteQuizMutation, useUpdateQuizMutation, usePostQuizMutation, useGetSQuizQuery } = quizApi;